<template>
  <div class="online-courses">
    <div v-if="recordings && recordings.length">
      <h2>Onlinekurs / Aufzeichnung</h2>
      <div
        class="course-content"
        v-if="recordContent"
        v-html="textToMarkdown(recordContent.value)"
      ></div>

      <div class="recordings-wrapper">
        <div
          v-if="courseLoader"
          class="big-loader fa fa-spinner fa-pulse fa-2x"
        ></div>

        <template v-if="recordings">
          <div v-if="!recordings.length" class="alert alert-info">
            Wir bereiten gerade die Onlinekurse für Sie vor. Schauen Sie bitte
            demnächst nochmal vorbei.
          </div>

          <course-information-box
            v-for="course in recordings"
            :key="'recording-' + course._id"
            :course="course"
          ></course-information-box>
        </template>
      </div>
    </div>

    <div v-if="webinars && webinars.length">
      <h2>Liveübertragungen</h2>
      <div
        class="course-content"
        v-if="webinarContent"
        v-html="textToMarkdown(webinarContent.value)"
      ></div>

      <div class="webinars-wrapper">
        <div
          v-if="courseLoader"
          class="big-loader fa fa-spinner fa-pulse fa-2x"
        ></div>

        <template v-if="webinars">
          <div v-if="!webinars.length" class="alert alert-info">
            Webinare werden zur Zeit nicht angeboten.
          </div>

          <course-information-box
            v-for="course in webinars"
            :key="'webinar-' + course._id"
            :course="course"
          ></course-information-box>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import CourseInformationBox from './CourseInformationBox';
import { textToMarkdown } from '../../_shared/hooks/useTextHelper';

const webinarContentCode = 'page.online-courses.webinar';
const recordContentCode = 'page.online-courses.record';

export default {
  components: { CourseInformationBox },
  data() {
    return {
      courseLoader: true,
    };
  },
  computed: {
    webinarContent() {
      return (
        this.$store.state.contentItems &&
        this.$store.state.contentItems.find(
          (item) => item.code === webinarContentCode
        )
      );
    },
    recordContent() {
      return (
        this.$store.state.contentItems &&
        this.$store.state.contentItems.find(
          (item) => item.code === recordContentCode
        )
      );
    },
    webinars() {
      if (!this.$store.state.courses) {
        return;
      }

      return this.$store.state.courses.filter(
        (cycle) => !!cycle.webinar && !!cycle.active
      );
    },
    recordings() {
      if (!this.$store.state.courses) {
        return;
      }

      return this.$store.state.courses.filter(
        (cycle) => !!cycle.recording && !!cycle.active
      );
    },
  },
  methods: {
    textToMarkdown,
  },
  mounted() {
    this.$store.dispatch('loadContentItem', 'page.online-courses.webinar');
    this.$store.dispatch('loadContentItem', 'page.online-courses.record');
    this.$store.dispatch('loadCycles').then(() => {
      this.$store.dispatch('loadCourses', { with: ['page'] }).then(() => {
        this.courseLoader = false;
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.online-courses {
  margin: 10px 0;

  h2 {
    align-content: end;
    height: 80px;
  }

  .course-content {
    display: flex;
    justify-content: center;
    margin: 0 auto 16px;
    max-width: 920px;
  }

  .recordings-wrapper,
  .webinars-wrapper {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: 1fr;

    > div {
      height: fit-content;
    }
  }
}

@media screen and (min-width: 48rem) and (max-width: 63.25rem) {
  .online-courses {
    .recordings-wrapper,
    .webinars-wrapper {
      grid-gap: 12px;
      grid-template-columns: 1fr 1fr;
    }
  }
}

@media screen and (min-width: 80rem) {
  .online-courses {
    .recordings-wrapper,
    .webinars-wrapper {
      grid-gap: 12px;
      grid-template-columns: 1fr 1fr;
    }
  }
}
</style>
